/* Copyright Information: Created by BuyGroup */
import Api from "../Api";

export const adminList = () => {
  return Api.get("user/admins").then((res) => res.data);
};

export const addAdmin = (adminData) => {
  return Api.post("user/admins", adminData).then((res) => res.data);
};

export const updateAdmin = (adminData) => {
  return Api.put("user/admins", adminData).then((res) => res.data);
};

export const deleteAdmin = (id) => {
  return Api.delete("user/admins/" + id).then((res) => res.data);
};

/* Copyright Information: Created by BuyGroup */




